module.exports = __webpack_public_path__ + "static/media/top.c0e5f3b6.png";